import axios from 'axios';
import env from '@utils/env';

const unloggedFetcher = (url, queryParams = '') =>
  axios.get(`${env.API}${url}${queryParams}`).then((res) => res.data);

export default unloggedFetcher;
